export default {
  data () {
    return {
      adminSectionsPage: {
        sectionTypeOrder: {},
        sectionCustomOrder: {}
      }
    }
  },
  computed: {
    getPage () {
      return this.page
    },
    getAllSections () {
      const result = [
        ...this.getPage.sections || [],
        ...this.getPage.faqs?.map((i, indexOfType) => {
          return {
            indexOfType,
            type: 'faq-item',
            ...i
          }
        }) || [],
        ...this.getPage.galleries?.map((i, indexOfType) => {
          return {
            indexOfType,
            type: 'gallery',
            ...i
          }
        }) || []
      ].map((section, index) => {
        const customIndex = this.adminSectionsPage.sectionCustomOrder[`${section.type}:${section.indexOfType}`]
        return {
          ...section,
          index: customIndex !== undefined ? customIndex : index

        }
      })

      return result.sort((a, b) => {
        const typeOrderA = this.adminSectionsPage.sectionTypeOrder[a.type] || 999
        const typeOrderB = this.adminSectionsPage.sectionTypeOrder[b.type] || 999

        if (typeOrderA !== typeOrderB) {
          return typeOrderA - typeOrderB
        }

        return a.index - b.index
      })
    },
    getAllTextSections () {
      return this.getAllSections.filter(s => s.type === 'section-text') || []
    },
    getAllGalleries () {
      return this.getAllSections?.filter(i => i.type === 'gallery') || []
    },
    getAllFAQ () {
      return this.getAllSections?.filter(i => i.type === 'faq-item') || []
    },
    getAllFeatures () {
      return this.getAllSections?.filter(i => i.type === 'feature-item') || []
    }
  }
}
